<template>
  <div class="browse_details" v-if="hide">
    <div class="browse_detailsnav">
      <div class="evolution_left_txt">
        <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px"></div>
        <div class="evolution_txt" style="cursor: pointer" @click="tiao">
          首页 <span class="span1">></span>
          <span class="span1" @click.stop="tiao2">{{ list2.journalName }}</span>
          <span class="span1">></span>
          <span class="span1" @click.stop="tiao2">{{ list2.yearVolumeIssue }}</span>
          <span class="span1">></span>
          <span class="span2">{{ list2.channelName }}</span>
        </div>
      </div>
      <div class="browse_detailnav1">
        <div class="browse_top">
          <div class="spanone">
            《{{ list2.journalName }}》<span class="span2">{{
              list2.yearVolumeIssue
            }}</span
            >{{ list2.channelName }}
          </div>
        </div>
        <div class="browse_bottom">
          <div v-if="list2.otherName" style="cursor: pointer">
            <img
              :src="list2.otherName"
              style="width: 100px; height: 100px; margin-left: 20px"
            />
            <div style="padding-left: 8px; font-size: 14px; text-align: center">
              扫描二维码观看视频
            </div>
          </div>

          <div style="flex: 1">
            <div class="browse_txt1">{{ list2.title }}</div>

            <!-- <div class="browse_txt2">
            <span>点击：{{list2.hits}}</span>
            <span>下载：{{list2.downloads}}</span>
            <span>更新日期：2020-01-02</span>
          </div> -->

            <div class="browse_txt3">作者：{{ list2.authors }}</div>
          </div>
          <div style="margin-right: 20px">
            <div class="browse_down" @click="down(list2.contentId)">
              <span class="iconfont iconxiazai"></span>PDF下载
            </div>
            <div
              v-if="list2.filePath2"
              class="browse_down"
              style="margin-top: 10px"
              @click="open(list2.filePath2)"
            >
              <span class="iconfont iconxiazai"></span>附件下载
            </div>
            <div
              v-if="list2.otherPath"
              class="browse_down"
              @click="downVideo(list2.otherPath)"
              style="margin-top: 10px"
            >
              <span class="iconfont iconxiazai"></span>观看视频
            </div>
          </div>

          <!-- <div class="browse_txt4">引用本文：</div> -->
          <!-- <div class="browse_txt5">陈漪,周俭,樊嘉,等.术中射频消融治疗合并重度肝硬化肝细胞癌的临床疗效及预后因素分析[J].中华消化外科杂志,2017,16(2):159-163.DOI:10.3760/cma.j.issn.1673-9752.2017.02.010.引用本文</div> -->
        </div>
        <div class="browse_abstract">
          <div class="browse_abstractnav">
            <div class="browse_txt1" style="margintop: 30px">引用文本：</div>
            <div v-html="list2.reference"></div>
            <div class="browse_txt1" style="margintop: 100px">摘要</div>
            <div class="browse_txt2">
              <div v-html="list2.abstract"></div>
              <div class="browse_english">【Abstract】</div>
              <div v-html="list2.enAbstract"></div>
            </div>
            <div class="browse_txt3">
              <div><span>关键词：</span>{{ list2.keywords }}</div>
              <div><span>作者：</span>{{ list2.authors }}</div>
              <div><span>单位：</span>{{ list2.workUnit }}</div>
              <div><span>DOI：</span>{{ list2.doi }}</div>
              <div><span>基金项目：</span>{{ list2.funds }}</div>
            </div>
          </div>
        </div>
        <div class="browse_literature">
          <div class="can">
            <div class="cankao">文献参考</div>
            <div>{{ list2.reference }}</div>
          </div>
        </div>
        <div
          class="shang"
          v-if="list2.upContentTitle != null || list2.nextContentTitle != null"
        >
          <div
            class="shang_nav"
            v-if="list2.upContentTitle != null && list2.nextContentTitle != null"
          >
            <div class="shangl">
              上一篇：<span>{{ list2.upContentTitle }}</span>
            </div>
            <div class="shangr">
              下一篇：<span>{{ list2.nextContentTitle }}</span>
            </div>
          </div>
          <div
            class="shang_nav"
            v-if="list2.upContentTitle != null || list2.nextContentTitle != null"
          >
            <div class="shangl" v-if="list2.upContentTitle != null">
              上一篇：<span>{{ list2.upContentTitle }}</span>
            </div>
            <div class="shangr" v-if="list2.nextContentTitle != null">
              下一篇：<span>{{ list2.nextContentTitle }}</span>
            </div>
          </div>
        </div>
        <!--        <div class="browse_recommend">
          <div class="one">
            <span class="one_xu"></span>
            <span class="one_xian"></span>
          </div>
          <div class="browse_recommendtxt">相关推荐</div>
          <div class="two">
            <span class="two_xian"></span>
            <span class="two_xu"></span>
          </div>
        </div>
        <div class="recommendtxt_list">
          <div class="express_nav2r">
            <div class="express_list2" v-for="(item,index) in list" :key="index" v-if="index<8" @mouseover="addtop(1,item.id)" @mouseout="addtop(2,item.id)">
              <div class="express_dian" :class="item.zt?'add2':''" ></div>
              <div class="express_wen" style="overflow: hidden;width: 96%;">
                <div class="wen1" :class="item.zt?'add1':''" style="float: left;">
                    <span class="span3" :class="item.zt?'add1':''">{{item.txt}}</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hide: false,
      list: [
        {
          id: 1,
          txt: "多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗123",
          time: "2020-03-25",
        },
        {
          id: 2,
          txt: "中国腹腔镜减重代谢外科20年研究中国腹腔镜减重代谢外科20年研究",
          time: "2020-03-25",
        },
        {
          id: 3,
          txt: "多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗",
          time: "2020-03-25",
        },
        {
          id: 4,
          txt: "多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗",
          time: "2020-03-25",
        },
        {
          id: 5,
          txt: "多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗",
          time: "2020-03-25",
        },
        {
          id: 6,
          txt: "多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗",
          time: "2020-03-25",
        },
        {
          id: 7,
          txt: "多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗",
          time: "2020-03-25",
        },
        {
          id: 8,
          txt: "多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗",
          time: "2020-03-25",
        },
        {
          id: 9,
          txt: "多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗",
          time: "2020-03-25",
        },
      ], //相关推荐
      list2: [],
    };
  },

  methods: {
    downVideo(path) {
      window.open(path);
    },
    //下载
    down(contentId) {
      var that = this;
      that.$httphelper
        .GetContentFilePath({
          journalId: 201607080003,
          contentId: contentId,
          downType: 1,
        })
        .then((res) => {
          if (res.code == 200) {
            window.open(res.data);
            that.$loading.hideLoading();
          } else {
            that.$alert("没有附件", "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        });
    },
    open(url) {
      window.open(url);
    },
    tiao() {
      this.$router.push({ path: "/home" });
    },
    tiao2() {
      this.$router.back();
    },
    //获取内容详情
    GetContentInfo() {
      sessionStorage.setItem("routerIndex", 4);
      var year = this.$route.query.year;
      var issue = this.$route.query.issue;
      var issuecid = this.$route.query.issuecid;
      var that = this;
      that.$httphelper
        .GetContentInfo({
          journalId: 201607080003,
          year: Number(year),
          issue: Number(issue),
          channelId: 0,
          contentId: Number(issuecid),
          dataSourceType: 3,
          dataShowType: 1,
        })
        .then((res) => {
          if (res.code == 200) {
            that.list2 = res.data.issueContentInfoResult || "";
            that.$loading.hideLoading();
            that.hide = true;
          } else {
            that.hide = true;
            that.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        });
    },
    //鼠标悬停
    addtop(num, id) {
      if (num == 1) {
        for (var i = 0; i < this.list.length; i++) {
          if (id == this.list[i].id) {
            this.list[i].zt = true;
            this.list.push("1");
            this.list.pop("1");
          }
        }
      } else {
        for (var i = 0; i < this.list.length; i++) {
          this.list[i].zt = false;
          this.list.push("1");
          this.list.pop("1");
        }
      }
    },
  },
  created() {
    this.GetContentInfo();
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.browse_details {
  width: 100%;
  min-width: 1366px;
  background-color: #ffffff;
  .browse_detailsnav {
    width: 85%;
    margin: 0 auto;
    overflow: hidden;
    margin-top: 24px;
    padding-bottom: 43px;
    .evolution_left_txt {
      width: 100%;
      overflow: hidden;
      margin-bottom: 25px;
      .evolution_tu {
        width: 19px;
        height: 17px;
        float: left;
      }

      .evolution_txt {
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #010101;

        .span1 {
          margin: 0 5px;
        }

        .span2 {
          color: var(--xt);
        }
      }
    }
    .browse_detailnav1 {
      width: 100%;
      margin-bottom: 18px;
      .browse_top {
        width: 100%;
        background-color: #f5f5f5;
        overflow: hidden;
        .spanone {
          width: 50%;
          overflow: hidden;
          margin: 0 auto;
          text-align: center;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #000000;
          line-height: 46px;
          .span2 {
            color: var(--xt);
            margin: 0 30px;
          }
        }
      }
      .browse_bottom {
        display: flex;

        width: 99.8%;
        border: 1px solid #ebebeb;
        border-top: none;
        padding: 40px 0 59px 0;
        position: relative;
        .browse_down {
          cursor: pointer;
          width: 129px;
          height: 44px;
          background: var(--xt);
          text-align: center;
          color: #ffffff;
          font-size: 16px;
          font-family: Adobe Heiti Std;
          font-weight: bold;
          color: #ffffff;
          line-height: 44px;
          span {
            font-size: 22px;
            margin-right: 9px;
          }
        }
        .browse_txt1 {
          width: 100%;
          text-align: center;
          font-size: 24px;
          font-family: Adobe Heiti Std;
          font-weight: bold;
          color: #000000;
          line-height: 24px;
          margin-bottom: 20px;
        }
        .browse_txt2 {
          width: 50%;
          margin: 0 auto;
          text-align: center;
          margin-bottom: 17px;
          span {
            font-size: 16px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #000000;
            line-height: 16px;
          }
        }
        .browse_txt3 {
          width: 100%;
          text-align: center;
          font-size: 14px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #959595;
          line-height: 15px;
          margin-bottom: 31px;
        }
        .browse_txt4,
        .browse_txt5 {
          width: 95%;
          color: #959595;
          line-height: 25px;
          margin: 0 auto;
          margin-bottom: 10px;
        }
        .browse_txt5 {
          margin-bottom: 0;
        }
      }
      .browse_abstract {
        width: 99.8%;
        border: 1px solid #ebebeb;
        padding: 23px 0 48px 0;
        .browse_abstractnav {
          width: 95%;
          margin: 0 auto;
          font-size: 16px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #000000;
          line-height: 30px;
          .browse_txt1 {
            width: 100%;
            margin-bottom: 20px;
            font-size: 18px;
            font-family: Adobe Heiti Std;
            font-weight: bold;
            color: #000000;
            line-height: 17px;
          }
          .browse_txt2 {
            width: 100%;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #000000;
            line-height: 30px;
            .browse_english {
              margin-top: 35px;
              margin-bottom: 10px;
            }
          }
          .browse_txt3 {
            width: 100%;
            margin-top: 35px;
            div {
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;
              line-height: 30px;
              span {
                font-weight: bold;
              }
            }
          }
        }
      }
      .browse_literature {
        width: 99.8%;
        border: 1px solid #ebebeb;
        padding: 32px 0 36px 0;
        margin-top: 20px;
        .can {
          width: 95%;
          margin: 0 auto;
          .cankao {
            width: 100%;
            margin-bottom: 30px;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            font-weight: bold;
            color: #000000;
            line-height: 16px;
          }
          .cankaotxt {
            width: 100%;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #343434;
            line-height: 30px;
          }
        }
      }
      .shang {
        width: 100%;
        background-color: #f7f7f7;
        margin-top: 20px;
        .shang_nav {
          width: 80%;
          overflow: hidden;
          margin: 0 auto;
          .shangl,
          .shangr {
            width: 45%;
            float: left;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            color: #000000;
            line-height: 48px;
            cursor: pointer;
            white-space: nowrap; //强制字体不换行
            text-overflow: ellipsis; //超出字体隐藏
            overflow: hidden;
            span:hover {
              color: var(--biao);
              text-decoration: underline;
            }
          }
          .shangl {
            margin-right: 10%;
          }
          .shangl2,
          .shangr2 {
            width: 100%;
            text-align: center;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            color: #000000;
            line-height: 48px;
            cursor: pointer;
            white-space: nowrap; //强制字体不换行
            text-overflow: ellipsis; //超出字体隐藏
            overflow: hidden;
            span:hover {
              color: var(--biao);
              text-decoration: underline;
            }
          }
        }
      }
      .browse_recommend {
        width: 100%;
        overflow: hidden;
        margin-top: 49px;
        .one {
          width: 43%;
          float: left;
          overflow: hidden;
          margin-top: 14px;
          .one_xu {
            width: 85%;
            height: 1px;
            border-bottom: 1px dashed #e4e4e4;
            display: block;
            float: left;
          }
          .one_xian {
            width: 15%;
            height: 1px;
            background-color: var(--biao);
            display: block;
            float: left;
          }
        }
        .browse_recommendtxt {
          width: 14%;
          float: left;
          text-align: center;
          font-size: 20px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #000000;
          line-height: 28px;
        }
        .two {
          width: 43%;
          float: left;
          overflow: hidden;
          margin-top: 14px;
          .two_xu {
            width: 85%;
            height: 1px;
            border-bottom: 1px dashed #e4e4e4;
            display: block;
            float: left;
          }
          .two_xian {
            width: 15%;
            height: 1px;
            background-color: var(--biao);
            display: block;
            float: left;
          }
        }
      }
      .recommendtxt_list {
        width: 99.8%;
        border: 1px solid #ebebeb;
        padding: 30px 0 36px 0;
        margin-top: 43px;
        .express_nav2r {
          width: 95%;
          overflow: hidden;
          margin: 0 auto;
          .express_list2 {
            width: 100%;
            overflow: hidden;
            cursor: pointer;
            margin-bottom: 45px;
            line-height: 20px;
            .express_dian {
              width: 10px;
              height: 10px;
              background: #dbdbdb;
              border-radius: 50%;
              margin-right: 25px;
              float: left;
              margin-top: 5px;
            }

            .express_wen {
              width: 91%;
              float: left;

              .wen1 {
                width: 100%;
                font-size: 16px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #000000;

                .span3 {
                  width: 100%;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  float: left;
                }
              }

              .wen2 {
                width: 100%;
                font-size: 14px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #636363;
                margin-bottom: 10px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }

            .zhai {
              width: 90%;
              padding-left: 31px;
              overflow: hidden;
              float: left;

              .wen3 {
                width: 50%;
                font-size: 14px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #636363;
                float: left;
              }

              .zhai_left,
              .zhai_right {
                font-size: 14px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #000000;
                float: right;
              }

              .zhai_right {
                margin-left: 30px;
              }

              .zhai_left:hover {
                text-decoration: underline;
                color: var(--biao);
              }

              .zhai_right:hover {
                text-decoration: underline;
                color: var(--biao);
              }
            }
          }
          .express_list2:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
.add1 {
  color: var(--xt) !important;
  text-decoration: underline;
}

.add2 {
  background-color: var(--xt) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/secondary/browse_details.vue